'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const isMotionValue = require('../../../value/utils/is-motion-value.js');
const isForcedMotionValue = require('../../../motion/utils/is-forced-motion-value.js');

function scrapeMotionValuesFromProps(props) {
  var style = props.style;
  var newValues = {};
  for (var key in style) {
    if (isMotionValue.isMotionValue(style[key]) || isForcedMotionValue.isForcedMotionValue(key, props)) {
      newValues[key] = style[key];
    }
  }
  return newValues;
}

exports.scrapeMotionValuesFromProps = scrapeMotionValuesFromProps;
